import { useIntl } from 'react-intl';

import MapIcon from '@/assets/icons/bullseye-line.svg';
import EmptyMappingIcon from '@/assets/icons/empty-mapping.svg';
import { EmptyState } from '@/components/ui/empty-state';

import { EditStageMappings } from './edit-stage-mappings';

export function NoMapping({
  hiringGoalConversionRate,
  refetchFunnelData,
}: {
  hiringGoalConversionRate: number | null;
  refetchFunnelData: () => Promise<void>;
}) {
  const intl = useIntl();

  return (
    <div className="border-fx-neutral-200 flex h-full max-h-full flex-1 gap-8 overflow-hidden rounded-lg border bg-white pb-8">
      <EditStageMappings
        funnelData={[]}
        hiringGoalConversionRate={hiringGoalConversionRate}
        refetchFunnelData={refetchFunnelData}
      >
        <EmptyState
          icon={EmptyMappingIcon}
          header={intl.formatMessage({
            defaultMessage: 'Map now to enable tracking',
            description:
              'Empty funnel state headline: user must connect ATS stages to sourcing',
          })}
          description={intl.formatMessage({
            defaultMessage: 'Hire stages aren’t mapped to source stages yet.',
            description:
              'Explains why funnel metrics are empty until mapping is done',
          })}
          buttonIcon={MapIcon}
          buttonTitle={intl.formatMessage({
            defaultMessage: 'Map',
            description: 'CTA to open the stage-mapping configuration flow',
          })}
        />
      </EditStageMappings>
    </div>
  );
}
